import { Component, Input, OnInit } from '@angular/core';
import { ListTableComponent } from '../../../shared/components/list-table/list-table.component';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { BillingService } from '../../../services/billing.service';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'ppl-claim-report',
  standalone: true,
  imports: [
    ListTableComponent,
    ButtonComponent,
    FormsModule,
    ReactiveFormsModule,
    NzFormModule,
    NzInputModule,
  ],
  templateUrl: './claim-report.component.html',
  styleUrl: './claim-report.component.css',
})
export class ClaimReportComponent implements OnInit {
  @Input() claimReportData: any;
  @Input() id: any;
  programName: any;
  claimReportSearchForm!: FormGroup;
  errorMsg: any;

  claimCols = [
    {
      field: 'fieldName',
      header: 'Field Name',
      jsonpath: 'fieldName',
    },
    {
      field: 'fieldNumber',
      header: 'Field Number',
      jsonpath: 'fieldNumber',
    },
    {
      field: 'fieldValue',
      header: 'Value',
      jsonpath: 'fieldValue',
    },
  ];

  constructor(
    private fb: FormBuilder,
    private billingService: BillingService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
 const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.claimReportSearchForm = this.fb.group({
      fieldName: [''],
    });
  }

  search() {
    this.errorMsg = '';
    const fieldName = this.claimReportSearchForm.value?.fieldName?.trim();
    if (fieldName && fieldName.length < 3) {
      this.errorMsg = 'Please enter at least 3 characters to search.';
      return;
    } else {
      const payload = {
        reportName: 'fetchBatchClaims',
        mcoName: null,
        batchDate: null,
        reportBy: null,
        claimType: null,
        batchClaimId: this.id,
        splitBy: null,
        ignoreReason: null,
        claimFieldName: fieldName,
        programCode: this.programName,
      };

      this.billingService
        .getClaimReportGridData(payload)
        .subscribe((data: any) => {
          if (data.status === 200) {
            this.claimReportData = data.responsedata;
          }
        });
    }
  }
}
